// React Query keys for Reviews (under ['shop', id] so shop-wide invalidation reaches them).
export const reviewKeys = {
  list: (shopId: string) => ['shop', shopId, 'reviews'] as const,
};
